import { gql } from "@apollo/client/core";

/**
 * Live-chat subscription documents.
 *
 * These target the AppSync API (a separate schema/endpoint from the main Apollo
 * GraphQL API), so they're hand-written rather than generated by codegen — the
 * codegen schema only covers the Apollo API. The Apollo `split` link
 * (apollo.tsx) routes these subscription operations to AppSync over WebSocket.
 */

export interface MessageEvent {
    id: string;
    chatId: string;
    authorId: string | null;
    body: string;
    createdAt: string;
    senderKind: string;
}

export type ChatListEventKind =
    | "NEW_MESSAGE"
    | "MESSAGE_UPDATED"
    | "MESSAGE_DELETED"
    | "CREATED"
    | "PARTICIPANT_ADDED"
    | "PARTICIPANT_REMOVED"
    | "DELETED"
    /** The caller read a chat on one of their own devices — their others are now stale. */
    | "READ";

export interface ChatListEvent {
    chatId: string;
    kind: ChatListEventKind;
    name: string | null;
    updatedAt: string;
    lastMessageBody: string | null;
    lastMessageAt: string | null;
}

/** New messages within a single chat (subscribe with the chat's id). */
export const ON_MESSAGE = gql`
    subscription OnMessage($chatId: ID!) {
        onMessage(chatId: $chatId) {
            id
            chatId
            authorId
            body
            createdAt
            senderKind
        }
    }
`;

/** Changes to the caller's chat list (new chats, last message, membership). */
export const ON_CHAT_LIST_UPDATE = gql`
    subscription OnChatListUpdate {
        onChatListUpdate {
            chatId
            kind
            name
            updatedAt
            lastMessageBody
            lastMessageAt
        }
    }
`;
